import {
  DomainName,
  IMultilineTextInputControl,
  StringDomain,
  TControlName,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  FormControlViewModelType,
  LocalizedProps,
  MultilineFormControlViewModel,
} from '../../view-model/FormControlViewModel';
import { FormSource, FormSourceType } from '../../view-model/FormSource';

import { controlDomain, getValueFromArgsOrConfig } from './helpers';

const buildMultilineControl = async (
  item: IMultilineTextInputControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  source: FormSource,
  domains: Array<{ name: TControlName; domain: DomainName }>
): Promise<MultilineFormControlViewModel> => {
  const domain = (await controlDomain(item, source, domains)) as StringDomain;
  return {
    columns: item.columns,
    noLabel: item.noLabel,
    type: FormControlViewModelType.MULTILINE,
    name: item.name,
    hasValue: true,
    hasHistory: false,
    highlightLanguage: item.highlightLanguage,
    value: getValueFromArgsOrConfig(item, args, source, ''),
    labelWidth: item.labelWidth,
    lengthInBytes: domain.lengthInBytes,
    maxLength: domain.length,
    required: item.required,
    disabled: item.disabled,
    storeValue: item.storeValue,
    readonly: item.readonly || source.type === FormSourceType.REVIEW,
    rows: item.rows || 3,
    trim: item.trim,
    visible: item.visible,
    expandable: item.expandable,
    ...localizedProps,
  };
};

export default buildMultilineControl;
